import {
  localizedPaymentStatuses,
  PaymentStatusesEnum
} from '../types/PaymentStatusesEnum';
import {
  localizedPaymentRefundStatuses,
  PaymentRefundStatusEnum
} from '../types/PaymentRefundStatusEnum';

// сличение для названия платёжной системы
export const getPaymentProviderLabel = (provider: string): string => {
  switch (provider) {
    case 'dolymi':
      return 'Тинькофф.Долями';
    case 'sberbank':
      return 'Сбербанк';
    case 'cash':
      return 'Наличные';
    default:
      return provider;
  }
};

/**
 * Статусы оплаты заказа для фильтра. `canceled` — с PAR-5189: до этого 606
 * таких заказов стенда отобрать было нечем.
 */
export const paymentStatusOptions = [
  { value: '', label: 'Не выбрано' },
  ...Object.values(PaymentStatusesEnum).map((status) => ({
    value: status,
    label: localizedPaymentStatuses[status]
  }))
];

const deprecatedStatusReplacement: Record<string, string> = {
  new_created: 'not_paid',
  rejected: 'not_paid',
  wait_for_commit: 'not_paid',
  approved: 'not_paid'
};

// сличение для статуса оплаты
export const getPaymentStatusLabel = (status: string | null): string | null => {
  if (status === null || status === undefined || status === '') return null;

  const actualStatus =
    status in deprecatedStatusReplacement
      ? deprecatedStatusReplacement[status]
      : status;

  switch (actualStatus) {
    case 'error':
      return 'Ошибка';
    case 'not_paid':
      return 'Не оплачен';
    case 'paid':
      return 'Оплачен';
    case 'canceled':
      return 'Отменен';
    case 'refund':
      return 'Частичный возврат';
    default:
      return actualStatus;
  }
};

/**
 * Проверяет, что статус заявки на возврат — один из описанных в Swagger.
 * @param status - статус из ответа бэка
 * @returns true, если статус известен
 */
const isPaymentRefundStatus = (
  status: string
): status is PaymentRefundStatusEnum =>
  status === PaymentRefundStatusEnum.NEW ||
  status === PaymentRefundStatusEnum.APPROVED ||
  status === PaymentRefundStatusEnum.REJECTED;

/**
 * Подпись статуса заявки на возврат ДС. Неизвестный статус возвращается как
 * есть — бэк может прислать значение вне перечисления Swagger.
 * @param status - статус из ответа бэка
 * @returns подпись для интерфейса
 */
export const getPaymentRefundStatusLabel = (status: string | null): string => {
  if (status === null || status === '') return 'Статус отсутствует';
  return isPaymentRefundStatus(status)
    ? localizedPaymentRefundStatuses[status]
    : status;
};

// сличение для статус заказа
export const getOrderStatusLabel = (status: string): string | null => {
  switch (status) {
    case 'created':
      return 'Создан';
    case 'accepted':
      return 'Принят';
    case 'confirmed':
      return 'Подтверждён';
    case 'packing':
      return 'Заказ упаковывается';
    case 'packed':
      return 'Заказ упакован';
    case 'delivering':
      return 'Доставляется';
    case 'wait_receipt':
      return 'Ожидает чека';
    case 'delivered':
      return 'Доставлен';
    case 'received':
      return 'Получен';
    case 'part_received':
      return 'Частично получен';
    case 'canceled':
      return 'Отменён';
    default:
      return status;
  }
};

// сличение для статус промокода

export const getPromocodeStatusLabel = (status: string): string | null => {
  switch (status) {
    case 'success':
      return 'Успешно использован';
    case 'inactive':
      return 'Промокод не активен';
    case 'already_used':
      return 'Промокод уже был использован';
    case 'min_amount':
      return 'Неправильная минимальная сумма заказа';
    case 'not_exist':
      return 'Промокод не существует';
    default:
      return status;
  }
};
